var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorites-btn",class:{active: _vm.doc.isInFavorite},on:{"click":_vm.toggleFavorites}},[_c('i',{staticClass:"fas fa-star"}),_c('span',{staticClass:"addTo"},[_vm._v(" Add to ")]),_c('span',{staticClass:"in"},[_vm._v(" In ")]),_vm._v(" Favorites ")])
}
var staticRenderFns = []

export { render, staticRenderFns }